import { Tooltip } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { BASE_URL } from "../constants.tsx";
import { useHistory } from "react-router-dom";
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';



const Clipboard = ({ text, formName }) => {
  const [copy, setCopy] = useState("Copy");
  //   const [FormName, setFormName] = useState(formName);
  //   const history = useHistory()
  //   useEffect(() => {
  //     setFormName()
  // }, [])
  // const localHistory = localStorage.setItem('copyUrlParams',`${BASE_URL+`/`+'coaching_request_form'+`/`+ text}`);
  return (
    <React.Fragment> <Tooltip title={copy} placement="top">
      <a target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "black" }}
      //  href={`${ BASE_API_URL + `/coaching_request_form/`+text}`}
      // href={`${BASE_API_URL+`/`+'coaching_request_form'+`/`+ text}`}
      >

        <TextField style={{ width: '57%' }} id="outlined-basic" value={`${BASE_URL + `/` + formName + `/` + text}`} variant="outlined" InputLabelProps={{ style: { fontSize: "16px", fontFamily: "Open Sans" } }}
          InputProps={{ style: { fontSize: "16px", fontFamily: "Open Sans", padding: "0px" } }} /> &nbsp;&nbsp;&nbsp;

        <CopyToClipboard
          text={`${BASE_URL + `/` + formName + `/` + text}`}
          onCopy={() => { setCopy("Copied!"); localStorage.setItem('copyUrlParams', `${BASE_URL + `/` + formName + `/` + text}`); }}
          onMouseEnter={() => setCopy("Copy")}
        >
          {/* <div>{text}</div> */}
          <Button style={{ textTransform: "initial" }} variant="contained">Copy url</Button>
        </CopyToClipboard>


      </a>
    </Tooltip>
    </React.Fragment>
  );
};

export default Clipboard;
